<template>
  <article class="network-training-card training-case-card">
    <div v-if="showImage" class="training-case-cover">
      <img :src="cover" :alt="coverAlt" @error="imageFailed = true">
    </div>
    <case-library-banner v-else :platform="platform" :category="category" :theme-index="themeIndex" />
    <slot />
  </article>
</template>

<script>
import CaseLibraryBanner from './CaseLibraryBanner.vue'
import { isCaseCoverImage } from '../services/caseCover'

export default {
  name: 'TrainingCaseCard',
  components: { CaseLibraryBanner },
  props: {
    platform: { type: String, default: 'network' },
    category: { type: String, default: '' },
    themeIndex: { type: Number, default: 0 },
    cover: { type: String, default: '' },
    coverAlt: { type: String, default: '案例封面' }
  },
  data () { return { imageFailed: false } },
  computed: { showImage () { return !this.imageFailed && isCaseCoverImage(this.cover) } },
  watch: { cover () { this.imageFailed = false } }
}
</script>
